import React, {useEffect, useState} from 'react';
import {
  Box,
  Paper,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Grid,
  Divider,
  Stack,
  Container,
  Card,
  Avatar,
  CardContent
} from '@mui/material';
import Api from "../Services/ApiPublic"
import meanBy from 'lodash/meanBy';
import DataTable from '../Components/DataTable'

const peserta = {
  nama: 'Brilyan Setiawan',
  ttl: 'Jakarta, 14 Februari 2000',
  dojo: 'Dojo Jakarta',
  sabuk: 'Coklat',
  nomorPeserta: 'PSR202401',
  foto: 'https://via.placeholder.com/150' // Ganti dengan URL foto asli
};

export default function ResultPage() {
    const [resultData, setResultData] = useState([])
    const [profileData, setProfileData] = useState({})

    const params = new URLSearchParams(window.location.search);
    const event_id = params.get('event_id');
    const participant_id = params.get('participant_id');

    const fecthData = async()=>{
        const _response = await Api.getResultData(event_id, participant_id)
        console.log('_response', _response)
        setResultData(_response)
        setProfileData(_response[0])
    }
    useEffect(()=>{
        fecthData()
    },[])

    function formatTanggalIndo(tanggalString) {
        
        if(tanggalString)
        {
            const tanggal = new Date(tanggalString);

            return new Intl.DateTimeFormat('id-ID', {
                day: 'numeric',
                month: 'long',
                year: 'numeric'
            }).format(tanggal);
        }
        else{
            return ""
        }
    }

    function getHariIndo(tanggalString) {
        if(tanggalString)
        {
            const tanggal = new Date(tanggalString);
  
            return new Intl.DateTimeFormat('id-ID', {
                weekday: 'long',
            }).format(tanggal);
        }
        else{
            return ""
        }
  
}
  return (
    <Container maxWidth="xl"  sx={{p:1}}>
        <Box>
            <Card elevation={4} sx={{ p: 3}}>
                <Grid container spacing={5} alignItems="center">
                    {/* Foto */}
                    <Grid item xs={4} sm={4} md={4}>
                    <Box display="flex" justifyContent="center">
                        <Avatar
                        src={peserta.foto}
                        alt={profileData?.FULL_NAME}
                        sx={{ width: 120, height: 120, border: '3px solid #1976d2' }}
                        />
                    </Box>
                    </Grid>

                    {/* Detail */}
                    <Grid item xs={8} sm={8} md={8}>
                    <CardContent>
                        <Typography variant="h4" gutterBottom>
                        {profileData?.FULL_NAME}
                        </Typography>
                        <Divider sx={{ mb: 1 }} />
                        <Typography variant="h6"><strong>Tempat, Tanggal Lahir:</strong> {profileData?.PLACEOFBIRTH}, {formatTanggalIndo(profileData?.DATEOFBIRTH)}</Typography>
                        <Typography variant="h6"><strong>Dojo:</strong> {profileData?.DOJO_NAME}</Typography>
                        <Typography variant="h6"><strong>Cabang:</strong> {profileData?.REGION_NAME}</Typography>
                    </CardContent>
                    </Grid>
                </Grid>
            </Card>
            <Paper elevation={3} sx={{ p: 2, mt:2 }}>
                <Typography variant='body2'>Pada Hari 
                    <b> {getHariIndo(profileData.START_DATE)}</b> Tanggal <b> {formatTanggalIndo(profileData.START_DATE)}</b> telah dilakukan penilaian oleh penguji 
                    <b> {profileData.EVALUATOR_NAME} </b> 
                    pada kegiatan Ujian 
                    <b> {profileData.EVENT_NAME} </b> 
                    Semester <b>{profileData.SEMESTER} </b> Tahun 
                    <b> {profileData.YEAR_EVENT} </b> yang bertempat di 
                    <b> {profileData.EVENT_PLACE} </b> 
                    dengan hasil sebagai berikut 
                </Typography>
            </Paper>
            <Paper elevation={3} sx={{ p: 2, mb: 4, mt:2 }}>
                <Grid container spacing={2}>
                    {
                        [{name:"KIHON", id:"ASS-01"}, {name:"KATA",id:"ASS-02"}, {name:"KUMITE", id:"ASS-03"}].map(assesment=>{
                            return(
                                <Grid item size={{xs:4,sm:4,md:4,lg:4,xl:4}}>
                                    <Stack direction="row" sx={{
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                    }}>
                                        <Typography variant='h5'>{assesment.name}</Typography>
                                        <Typography variant='h5'>
                                            Score : 
                                            {
                                                meanBy(resultData.filter(x=>x.PARENT_ID===assesment.id), item => Number(item.SCORE)).toFixed(2)
                                            }
                                        </Typography>
                                    </Stack>
                                        
                                    <DataTable
                                        headers={[
                                            {name : "No", align:'center',width:10},
                                            {name : "Item", align:'left'},
                                            {name : "Score", align:'center', width:150},
                                        ]}>
                                        {resultData.filter(x=>x.PARENT_ID===assesment.id).map((row, index) => 
                                        (
                                            <TableRow
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell align="center">
                                                    {index+1}
                                                </TableCell>
                                                <TableCell>
                                                    {row.ASSESMENT_NAME}
                                                </TableCell>
                                                <TableCell align='center'>
                                                    {row.SCORE}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </DataTable>
                                </Grid>
                            )
                        })
                    }
                    
                </Grid>
                <Paper elevation={3} sx={{ p: 2, mt:2 }}>
                    <Typography variant='h6'>
                        Total Score = (Avg KIHON x weight KIHON) + (Avg KATA x weight KATA) + (Avg KUMITE x weight KUMITE) 
                    </Typography>
                    {
                        resultData.length> 0 && 
                        <Typography variant='h5'>
                            Total Score : 
                            ( <b>{meanBy(resultData.filter(x=>x.PARENT_ID==="ASS-01"), item => Number(item.SCORE)).toFixed(2)} x {resultData.filter(x=>x.PARENT_ID==="ASS-01")[0].WEIGHT} %  = 
                            {(meanBy(resultData.filter(x=>x.PARENT_ID==="ASS-01"), item => Number(item.SCORE)) * resultData.filter(x=>x.PARENT_ID==="ASS-01")[0].WEIGHT / 100).toFixed(2)}
                            </b>
                            ) + 
                            ( <b>{meanBy(resultData.filter(x=>x.PARENT_ID==="ASS-02"), item => Number(item.SCORE))} x {resultData.filter(x=>x.PARENT_ID==="ASS-02")[0].WEIGHT} %  = 
                            {(meanBy(resultData.filter(x=>x.PARENT_ID==="ASS-02"), item => Number(item.SCORE)) * resultData.filter(x=>x.PARENT_ID==="ASS-02")[0].WEIGHT / 100).toFixed(2)}
                            </b>
                            ) + 
                            ( 
                            <b>{meanBy(resultData.filter(x=>x.PARENT_ID==="ASS-03"), item => Number(item.SCORE))}  x {resultData.filter(x=>x.PARENT_ID==="ASS-03")[0].WEIGHT} %  = 
                            {(meanBy(resultData.filter(x=>x.PARENT_ID==="ASS-03"), item => Number(item.SCORE)) * resultData.filter(x=>x.PARENT_ID==="ASS-03")[0].WEIGHT / 100).toFixed(2)}
                            </b>
                            ) = 
                            <b> {
                            ((meanBy(resultData.filter(x=>x.PARENT_ID==="ASS-01"), item => Number(item.SCORE)) * resultData.filter(x=>x.PARENT_ID==="ASS-01")[0].WEIGHT / 100)+
                            (meanBy(resultData.filter(x=>x.PARENT_ID==="ASS-02"), item => Number(item.SCORE)) * resultData.filter(x=>x.PARENT_ID==="ASS-02")[0].WEIGHT / 100)+
                            (meanBy(resultData.filter(x=>x.PARENT_ID==="ASS-03"), item => Number(item.SCORE)) * resultData.filter(x=>x.PARENT_ID==="ASS-03")[0].WEIGHT / 100)).toFixed(2)
                            }</b>
                        </Typography>
                    }
                    
                </Paper>
            </Paper>
        </Box>
    </Container>
    
  );
}
